import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module ComplaintsSaga
 */

/**
 *
 * @param {complaints} payload complains data
 */
export function setComplaints(complaints) {
  store.dispatch({
    type: actionTypes.SET_COMPLAINTS_DATA,
    payload: {
      complaints
    }
  });
}

export function setComplaintsCount(count) {
  store.dispatch({
    type: actionTypes.SET_COMPLAINTS_COUNT,
    payload: {
      count: count
    }
  });
}

export function setSelectedComplaint(complaintId, navigate) {
  store.dispatch({
    type: actionTypes.SET_SELECTED_COMPLAINT,
    payload: {
      complaintId,
      navigate
    }
  });
}

/**
 *
 * @param {data} payload complains data
 */
export function createComplaint(data, navigate, ieAccess) {
  store.dispatch({
    type: actionTypes.CREATE_COMPLAINTS,
    payload: {
      data,
      navigate,
      ieAccess
    }
  });
}

export function updateLinkComplaint(complaintId, data) {
  store.dispatch({
    type: actionTypes.UPDATE_LINK_COMPLAINT,
    payload: {
      complaintId,
      data
    }
  });
}

export function setFilter(data) {
  store.dispatch({
    type: actionTypes.SET_COMPLAINTS_FILTER,
    payload: {
      data
    }
  });
}

export function setSearchKey(data) {
  store.dispatch({
    type: actionTypes.SET_COMPLAINTS_SEARCH_KEY,
    payload: {
      data
    }
  });
}

export function setSortBy(data) {
  store.dispatch({
    type: actionTypes.SET_COMPLAINTS_SORT_BY,
    payload: {
      data
    }
  });
}

export function clearExistingComplaint() {
  store.dispatch({
    type: "CLEAR_EXISTING_COMPLAINT"
  });
}

export function showSelectedExistingComplaint(data, navigate) {
  store.dispatch({
    type: actionTypes.SHOW_SELECTED_EXISTING_COMPLAINT,
    payload: { data, navigate }
  });
}

export function setOfflineComplaints(data) {
  store.dispatch({
    type: actionTypes.SET_OFFLINE_COMPLAINTS,
    payload: { data }
  });
}

export function reopenComplaint(data, files, navigate) {
  store.dispatch({
    type: actionTypes.REOPEN_COMPLAINT,
    payload: { data, files, navigate }
  });
}

export function fetchSelectedComplaintAssets() {
  store.dispatch({
    type: actionTypes.FETCH_SELECTED_COMPLAINTS_ASSETS
  });
}
